import { render } from "./PlayerPoints.vue?vue&type=template&id=5f074a4b&scoped=true"
import script from "./PlayerPoints.vue?vue&type=script&lang=js"
export * from "./PlayerPoints.vue?vue&type=script&lang=js"

import "./PlayerPoints.vue?vue&type=style&index=0&id=5f074a4b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f074a4b"]])

export default __exports__